import React from "react";

const ContactBtn = () => {
    const scrollToSection = (id: string) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({
                behavior: "smooth",
                block: "start", // Aligns the section to the top of the viewport
            });
        }
    };

    return (
        <button className="btn-primary" onClick={() => scrollToSection("contact-us")}>
            <span className="material-symbols-outlined">sms</span>
            Contact Us
        </button>
    );
};

export { ContactBtn };
